"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacebookButton = exports.facebookShareAction = void 0;

var _sharing_helper = require("../../helpers/sharing_helper");

var _icons = require("../../assets/icons");

var _base = require("./base");

var facebookShareAction = function facebookShareAction(_ref) {
  var shareUrl = _ref.shareUrl,
      utmParams = _ref.utmParams;
  return (0, _sharing_helper.openPopup)("https://www.facebook.com/sharer/sharer.php?u=".concat((0, _sharing_helper.encodedShareURL)(shareUrl, utmParams)));
};

exports.facebookShareAction = facebookShareAction;
var FacebookButton = (0, _base.buildShareButtonComponent)({
  action: facebookShareAction,
  ariaLabel: 'Facebook',
  className: 'share-button--facebook',
  icon: _icons.FacebookIcon
});
exports.FacebookButton = FacebookButton;